import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { CustomSVG, ValidatedTextField } from 'components';
import { ContentInput } from 'api';

import { Switch, TextCounter } from '../';
import Widget from './WidgetContainer';

const MarkImportant: FC = () => {
  const { values, setFieldValue } = useFormikContext<ContentInput>();
  const { is_important, is_important_message } = values;

  function onChangeSwitch() {
    if (is_important) {
      setFieldValue('is_important_message', '');
    }

    setFieldValue('is_important', !is_important);
  }

  function renderBody() {
    return (
      <Grid container>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <ValidatedTextField
            name="is_important_message"
            i18nKey="posting:markImportantPlaceholder"
            TextFieldProps={{ margin: 'none', label: null, multiline: true, rows: 2 }}
            InputProps={{
              endAdornment: <TextCounter length={is_important_message.length} limit={110} />,
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid item xs>
      <Widget
        titleKey="posting:markImportantTitle"
        subtitleKey="posting:markImportantSubhead"
        icon={<CustomSVG name="flag" color={is_important ? 'inherit' : 'disabled'} />}
        toggle={<Switch checked={is_important} onChange={onChangeSwitch} color="primary" />}>
        {is_important && renderBody()}
      </Widget>
    </Grid>
  );
};

export default MarkImportant;
